import { render } from "./ScheduledVoice.vue?vue&type=template&id=f72bc8a2&scoped=true"
import script from "./ScheduledVoice.vue?vue&type=script&lang=js"
export * from "./ScheduledVoice.vue?vue&type=script&lang=js"

import "./ScheduledVoice.vue?vue&type=style&index=0&id=f72bc8a2&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f72bc8a2"]])

export default __exports__